import React, { useState, useRef } from 'react';
import { uploadImageApi } from '../../../BaseUrl'




const RestaurantImages = ({ thumbnailImage, setThumbnailImage, imagesArray, setImagesArray }) => {


    const inputFile = useRef(null)
    const thumbnailRef = useRef(null)
    const [loading, setloading] = useState(false);



    const onButtonClick = () => {
        // `current` points to the mounted file input element
        inputFile.current.click();
    };


    const onThumbnailButtonClick = () => {
        // `current` points to the mounted file input element
        thumbnailRef.current.click();
    };


    //make a function that will be called when the file is selected and conver the file to base64
    const handleFile = async (file) => {
        // `current` points to the mounted file input element
        const reader = new FileReader();


        reader.onload = async (e) => {
            setThumbnailImage(e.target.result);
            const res = await uploadImage(file);
            setThumbnailImage(res.data.imageUrl[0])
        };
        reader.readAsDataURL(file);
    };


    const uploadImage = async (image) => {
        const res = await uploadImageApi(image);
        return res;
    }





    //make a function that takes a object filelist and loops through it and converts it to base64 and set it to the images array

    const handleFileList = async (fileList) => {
        let temp = [...imagesArray]

        setloading(true) ;


        for (let i = 0; i < fileList.length; i++) {
            const res = await uploadImage(fileList[i]);
            temp.push(res.data.imageUrl[0])
        }

        console.log('images are', imagesArray)
        setImagesArray(temp)
        setloading(false)
    };


    // make a function to remove image from array by taking the index of the image and removing it from the array
    const removeImage = (index) => {

        setImagesArray(imagesArray.filter((image, i) => i !== index));

    };







    return (
        <div className="p-5 my-4">
            <div className="mt-8 p-4">
                <div className="flex justify-between">


                    <div className="bg-white h-40vh w-3/12 mr-2 mt-4 p-4 border border-gray-300 rounded-sm flex flex-col items-center">
                        <img className="w-90% h-25vh object-cover border border-gray-200" src={thumbnailImage || "https://media.musclegrid.io/karate4jax.com/uploads/2017/04/26233456/default-image.jpg"} />

                        <button className="w-90% bg-indigo-700 text-white px-3 mt-4  py-2 rounded-sm border-none" onClick={onThumbnailButtonClick}>Choose Image

                            <input
                                type="file"
                                ref={thumbnailRef}
                                onChange={(e) => handleFile(e.target.files[0])}
                                style={{ display: 'none' }}
                            />

                        </button>
                    </div>



                    <div className="ml-4 bg-white p-4 border border-gray-300 rounded-sm w-9/12">
                        <div className="flex items-center justify-between">
                            <p className="font-bold text-gray-600 text-md leading-8 uppercase h-6 mx-2 mt-3">
                                Restaurant Images (optional)
                            </p>
                            <button className="bg-indigo-700 text-white px-3 py-2 rounded-sm border-none" onClick={onButtonClick}>Upload Images</button>
                        </div>
                        <br />
                        <input type='file' id='file' multiple ref={inputFile} onChange={(e) => handleFileList(e.target.files)} style={{ display: 'none' }} />

                        <div className="flex  py-4 flex-wrap justify-between w-full ">

                            {
                                loading && 
                                <img src="https://i.pinimg.com/originals/35/b2/5a/35b25ac379b8e771bbd3fd956f4d31bb.gif" className="max-w-md mx-auto" />
                            }

                            {
                                !loading && imagesArray.length<1 &&
                                <img src="https://s3.amazonaws.com/blog.invisionapp.com/uploads/2017/04/gif-10.gif" className="max-w-md mx-auto" />
                            }

                            { imagesArray && imagesArray.map((image, index) => {
                                return (
                                    <div key={index} className="w-30% mx-2 ">
                                        <img src={image} className="border border-gray-300 max-w-sm m-2 w-full h-25vh  object-cover " />
                                        <button className="m-2 flex items-center" onClick={() => removeImage(index)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20px" height="20px"><path fill="#E04F5F" d="M504.1,256C504.1,119,393,7.9,256,7.9C119,7.9,7.9,119,7.9,256C7.9,393,119,504.1,256,504.1C393,504.1,504.1,393,504.1,256z" /><path fill="#FFF" d="M285,256l72.5-84.2c7.9-9.2,6.9-23-2.3-31c-9.2-7.9-23-6.9-30.9,2.3L256,222.4l-68.2-79.2c-7.9-9.2-21.8-10.2-31-2.3c-9.2,7.9-10.2,21.8-2.3,31L227,256l-72.5,84.2c-7.9,9.2-6.9,23,2.3,31c4.1,3.6,9.2,5.3,14.3,5.3c6.2,0,12.3-2.6,16.6-7.6l68.2-79.2l68.2,79.2c4.3,5,10.5,7.6,16.6,7.6c5.1,0,10.2-1.7,14.3-5.3c9.2-7.9,10.2-21.8,2.3-31L285,256z" /></svg>
                                            &nbsp;Remove</button>
                                    </div>
                                )
                            })}
                        </div>
                    </div>



                </div>
            </div>
        </div>
    );
}

export default RestaurantImages;
